<template>
  <div class="con-wrap">
    <header-con></header-con>
    <div id="bmap">
    </div>
    <div class="des-wrap pos-box" v-show="desFlag">
      <img src="../../../assets/images/GIS/close.png" alt="" @click="desFlag = false" class="close-img">
      <h2>{{companyInfo.divisionName}}</h2>
<!--      <p class="company-name">{{companyInfo.divisionName}}</p>-->
      <p class="msg-box">公司地址：{{companyInfo.address}}</p>
<!--      <p class="msg-box">公司简介：</p>-->
      <div class="des-con">
        <div id="companyDes">
          <p class="company-des" ref="companyDes" v-for="item in companyInfo.description">{{item}}</p>
        </div>
        <span v-if="showEllipsis">……</span>
      </div>
      <p class="more-btn" @click="goPage('companyInfo', companyInfo.id)">—— 点击查看更多 ——</p>
    </div>

    <!--  跳转按钮  -->
    <div class="btn-wrap">
      <el-button @click="goPage('integratedDisplay')" class="GIS-btn">企业总览</el-button>
      <el-button @click="goPage('companyInfo')" class="GIS-btn">企业简介</el-button>
      <el-button @click="goPage('video3d')" v-if="companyInfo.id == 7 || companyInfo.id == 6|| companyInfo.id == 62" class="GIS-btn">企业三维</el-button>
      <el-button @click="goPage('videoMonitoring')" class="GIS-btn">企业视频</el-button>
    </div>
  </div>
</template>

<script>
  import headerCon from "../../../components/header";
  import {BMPGL} from "../../../assets/js/tools/BMapGL";
  import companyInfo from "./companyInfo";
  import zhuangbei3d from "@/views/safetyManagement/video/zhuangbei3d";

  export default {
    name: "projectOverview",
    data(){
      return{
        divisionArr: [],
        desFlag: true,
        infoFlag: false,
        companyInfo: {},
        videoData: [],
        showEllipsis: false,
        companyDesH: 0,
        nowCompanyId: '',
        videoPath: '',
        videoName: '',
        centerPoint: [106.270747,38.0057401],        //地图中心点
        mapZoom: 6,
        secView: false,
        nowImg: '',
        labelArr: []
      }
    },
    components:{
      headerCon
    },
    mounted() {
      this.companyDesH = document.getElementById('companyDes').style.height;
      this.getData();
    },
    methods:{
      //页面跳转
      goPage(path){
        if(this.companyInfo.level ==1 || this.companyInfo.level ==2){
          if(path == 'video3d'){
            // if( this.companyInfo.id != 7 ){
            //   return false;
            // }
            if(this.companyInfo.id == 6) {
              path = 'zhuangbei3d';
            } else if(this.companyInfo.id == 62) {
              path = 'nanjing3d';
            }
          }
          this.$router.push({path: `/`+path, query: {id: this.companyInfo.id}});
          this.$cookie.set('companyInfoId', this.companyInfo.id);
        }
      },
      //公司列表
      getData( id ) {
        let nowId = id ? id : 0;
        this.$get('gisoverview/getdivisionlist' , [ nowId ]).then(
          (res) => {
            this.divisionArr = [];
            for( let i in res) {
              res[i].point = [];
              if(res[i].coordinate){
                res[i].point.push(res[i].coordinate.split(',')[0]*1);
                res[i].point.push(res[i].coordinate.split(',')[1]*1);
              }
              this.divisionArr.push(res[i]);

            }
            this.desFlag = true;
            if( nowId == 0 ){
              if(this.$route.query.id ){
                this.getCompanyInfo(this.$route.query.id);
              }else{
                this.getCompanyInfo(6);
              }
              this.mapZoom = 6;
              this.centerPoint = [106.270747,33.0057401];
            }else{
              this.centerPoint = this.divisionArr[0].point;
              this.mapZoom = 10;
            }
            this.initMap();
            if(this.$cookie.get('companyInfoId') != ''){
              this.getCompanyInfo(this.$cookie.get('companyInfoId'));
            }
          },
          (err) => {
            console.log(err);
            this.initMap();
          }
        )},
      initMap(){
        let _this = this;
        BMPGL().then((BMapGL) => {
          // let option = [
          //   {
          //   "featureType": "land",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "color": "#091220ff"
          //   }
          // }, {
          //   "featureType": "water",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "color": "#113549ff"
          //   }
          // }, {
          //   "featureType": "green",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "color": "#0e1b30ff"
          //   }
          // }, {
          //   "featureType": "building",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "building",
          //   "elementType": "geometry.topfill",
          //   "stylers": {
          //     "color": "#113549ff"
          //   }
          // }, {
          //   "featureType": "building",
          //   "elementType": "geometry.sidefill",
          //   "stylers": {
          //     "color": "#143e56ff"
          //   }
          // }, {
          //   "featureType": "building",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#dadada00"
          //   }
          // }, {
          //   "featureType": "subwaystation",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "color": "#113549B2"
          //   }
          // }, {
          //   "featureType": "education",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "medical",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "scenicspots",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "highway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "weight": "4"
          //   }
          // }, {
          //   "featureType": "highway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "highway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#fed66900"
          //   }
          // }, {
          //   "featureType": "highway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "highway",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "highway",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "highway",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "arterial",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "weight": "2"
          //   }
          // }, {
          //   "featureType": "arterial",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "arterial",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffeebb00"
          //   }
          // }, {
          //   "featureType": "arterial",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "arterial",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "arterial",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "local",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on",
          //     "weight": "1"
          //   }
          // }, {
          //   "featureType": "local",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "local",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "local",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "local",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#979c9aff"
          //   }
          // }, {
          //   "featureType": "local",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffffff"
          //   }
          // }, {
          //   "featureType": "railway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "subway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "weight": "1"
          //   }
          // }, {
          //   "featureType": "subway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#d8d8d8ff"
          //   }
          // }, {
          //   "featureType": "subway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "subway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "subway",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#979c9aff"
          //   }
          // }, {
          //   "featureType": "subway",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffffff"
          //   }
          // }, {
          //   "featureType": "continent",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "continent",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "continent",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "continent",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "city",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "city",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "city",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "city",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "town",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "town",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "town",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#454d50ff"
          //   }
          // }, {
          //   "featureType": "town",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffffff"
          //   }
          // }, {
          //   "featureType": "road",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "poilabel",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "districtlabel",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "road",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "road",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "road",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "district",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "poilabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "poilabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "poilabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "manmade",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "districtlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffffff"
          //   }
          // }, {
          //   "featureType": "entertainment",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "shopping",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "stylers": {
          //     "level": "6",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "stylers": {
          //     "level": "7",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "stylers": {
          //     "level": "8",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "stylers": {
          //     "level": "9",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "stylers": {
          //     "level": "10",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "6",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "7",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "8",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "9",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "10",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "6",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "7",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "8",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "9",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "10",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-10"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "stylers": {
          //     "level": "6",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "stylers": {
          //     "level": "7",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "stylers": {
          //     "level": "8",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "stylers": {
          //     "level": "9",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "6",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "7",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "8",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "9",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "6",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "7",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "8",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off",
          //     "level": "9",
          //     "curZoomRegionId": "0",
          //     "curZoomRegion": "6-9"
          //   }
          // }, {
          //   "featureType": "subwaylabel",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "subwaylabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "tertiarywaysign",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "tertiarywaysign",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "provincialwaysign",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "provincialwaysign",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "nationalwaysign",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "nationalwaysign",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "highwaysign",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "highwaysign",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "village",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "district",
          //   "elementType": "labels.text",
          //   "stylers": {
          //     "fontsize": "20"
          //   }
          // }, {
          //   "featureType": "district",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "district",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "country",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "country",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "water",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "water",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "tertiaryway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "tertiaryway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff10"
          //   }
          // }, {
          //   "featureType": "provincialway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "provincialway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "highway",
          //   "elementType": "labels.text",
          //   "stylers": {
          //     "fontsize": "20"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "nationalway",
          //   "elementType": "labels.text",
          //   "stylers": {
          //     "fontsize": "20"
          //   }
          // }, {
          //   "featureType": "provincialway",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "provincialway",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "provincialway",
          //   "elementType": "labels.text",
          //   "stylers": {
          //     "fontsize": "20"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "labels.text",
          //   "stylers": {
          //     "fontsize": "20"
          //   }
          // }, {
          //   "featureType": "cityhighway",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "estate",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "tertiaryway",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "tertiaryway",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "fourlevelway",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "fourlevelway",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "scenicspotsway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "scenicspotsway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "universityway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "universityway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "vacationway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "vacationway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "fourlevelway",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "fourlevelway",
          //   "elementType": "geometry.fill",
          //   "stylers": {
          //     "color": "#12223dff"
          //   }
          // }, {
          //   "featureType": "fourlevelway",
          //   "elementType": "geometry.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "transportationlabel",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "transportationlabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "transportationlabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "transportationlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "educationlabel",
          //   "elementType": "labels",
          //   "stylers": {
          //     "visibility": "on"
          //   }
          // }, {
          //   "featureType": "educationlabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "educationlabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "educationlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "transportation",
          //   "elementType": "geometry",
          //   "stylers": {
          //     "color": "#113549ff"
          //   }
          // }, {
          //   "featureType": "airportlabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "airportlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "scenicspotslabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "scenicspotslabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "medicallabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "medicallabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "medicallabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "scenicspotslabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "airportlabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "entertainmentlabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "entertainmentlabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "entertainmentlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "estatelabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "estatelabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "estatelabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "businesstowerlabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "businesstowerlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "businesstowerlabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "companylabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "companylabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "companylabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "governmentlabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "governmentlabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "governmentlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "restaurantlabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "restaurantlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "restaurantlabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "hotellabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "hotellabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "hotellabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "shoppinglabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "shoppinglabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "shoppinglabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "lifeservicelabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "lifeservicelabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "lifeservicelabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "carservicelabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "carservicelabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "carservicelabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "financelabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "financelabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "financelabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "otherlabel",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "otherlabel",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "otherlabel",
          //   "elementType": "labels.icon",
          //   "stylers": {
          //     "visibility": "off"
          //   }
          // }, {
          //   "featureType": "manmade",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "manmade",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "transportation",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "transportation",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "education",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "education",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "medical",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "medical",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }, {
          //   "featureType": "scenicspots",
          //   "elementType": "labels.text.fill",
          //   "stylers": {
          //     "color": "#2dc4bbff"
          //   }
          // }, {
          //   "featureType": "scenicspots",
          //   "elementType": "labels.text.stroke",
          //   "stylers": {
          //     "color": "#ffffff00"
          //   }
          // }];
          // 创建地图实例
          let map = new BMapGL.Map("bmap");
          // map.setMapStyleV2({styleJson:eval("option")});
          // let test = map.addControl(new BMapGL.MapTypeControl() );//控件，默认左上角
          // 创建点坐标 axios => res 获取的初始化定位坐标
          let point = new BMapGL.Point(_this.centerPoint[0], _this.centerPoint[1]);
          // 初始化地图，设置中心点坐标和地图级别
          map.centerAndZoom(point, _this.mapZoom);
          //开启鼠标滚轮缩放
          map.enableScrollWheelZoom(true);
          map.setTilt(10);      //倾斜程度
          for(let i in _this.divisionArr){
            let now = _this.divisionArr[i];
            _this.makePonit(map ,now)
          }
          //去掉百度地图logo
          let logo = document.getElementsByClassName('anchorBL')[0];
          logo.style.cssText  = 'display:none';
          let mask = document.getElementById('mask');
          mask.style['z-index'] = 1;
        })
          .catch((err)=>{
            console.log(err)
          })
      },
      //地图标记点
      makePonit( map, obj){
        let _this = this;
        let icon;
        //装备icon为红旗
        if(obj.id == 6){
          icon = new BMapGL.Icon(
            require('../../../assets/images/GIS/flag.png'),
            new BMapGL.Size(30, 30)
          )
        }else{
          if(obj.level == 1){
            icon = new BMapGL.Icon(
              require('../../../assets/images/GIS/l1.png'),
              new BMapGL.Size(30, 30)
            )
          }else if(obj.level == 2){
            icon = new BMapGL.Icon(
              require('../../../assets/images/GIS/l2.png'),
              new BMapGL.Size(30, 30)
            )
          }else if(obj.level == 3){
            icon = new BMapGL.Icon(
              require('../../../assets/images/GIS/l3.png'),
              new BMapGL.Size(30, 30)
            )
          }
        }

        let mkr = new BMapGL.Marker(new BMapGL.Point(obj.point[0], obj.point[1]), {icon: icon});
        if(obj.id == 6){
          mkr.setTop(true);
        }
        // let mkr = new BMapGL.Marker(new BMapGL.Point(obj.point[0], obj.point[1]));
        let labelOffest = [15, -10 ];
        if(obj.id == 7 || obj.id == 64|| obj.id== 60){
          labelOffest = [0, 10];
        }else if(obj.id == 55 || obj.id== 62 || obj.id == 8){
          labelOffest = [0, -30];
        }
        let label = new BMapGL.Label(obj.divisionName, { offset: new BMapGL.Size(labelOffest[0], labelOffest[1]) });
        let labelStyle = {
          color: "#6F87B0",
          fontSize: "16px",
          height: "20px",
          lineHeight: "20px",
          fontFamily: "微软雅黑",
          border: 'none',
          background: 'transparent',
          position: 'absolute',
          top: '10px',
          left: '20px',
          cursor: 'pointer'
        };
        label.setStyle(labelStyle);
        mkr.setLabel(label);
        map.addOverlay(mkr);
        this.labelArr.push(label);
        label.addEventListener("mouseover", function(e) {
          _this.labelArr.forEach(item => {
            if(item.content !== e.currentTarget.content) {
              item.setStyle({ color: "#6F87B0", 'fontSize': '16px' });
            } else {
              item.setStyle({ color: "#1949FF", 'fontSize': '18px' });
              _this.getCompanyInfo(obj.id);
            }
          })
          // label.setStyle({ color: "#f7d800", 'fontSize': '18px' });
          // _this.getCompanyInfo(obj.id);
        });
        // label.addEventListener("mouseout", function(e) {
        //   if(e.currentTarget.content === _this.companyInfo.divisionName) {
        //     label.setStyle({ color: "#f7d800", 'fontSize': '16px' });
        //   } else {
        //     label.setStyle({ color: "#fff", 'fontSize': '16px' });
        //   }
        // });
        label.addEventListener("click", function(e) {
          let now_id = obj.id;
          let title  = '';
          if(now_id != 6 && obj.level != 3){
            if( !_this.secView ){
              title = `是否进入 ${obj.divisionName} 主页`;
            }else{
              now_id = 0;
              title = `是否返回GIS主页`;
            }
            _this.$confirm(title, '', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: ''
            }).then(() => {
              _this.secView = !_this.secView;
              _this.getData( now_id );
            }).catch(() => {

            });
          }
        });
        mkr.addEventListener("mouseover", function(e) {
          _this.labelArr.forEach(item => {
            if(item.content !== e.target.getLabel().content) {
              item.setStyle({ color: "#6F87B0", 'fontSize': '16px' });
            } else {
              item.setStyle({ color: "#1949FF", 'fontSize': '18px' });
              _this.getCompanyInfo(obj.id);
            }
          })
          // label.setStyle({ color: "#f7d800", 'fontSize': '18px' });
          // _this.getCompanyInfo(obj.id);
        });
        // mkr.addEventListener("mouseout", function(e) {
        //   // var label = this.getLabel();
        //   label.setStyle({ color: "#ffffff", 'fontSize': '16px' });
        // });
        mkr.addEventListener("click", function(e) {
          let now_id = obj.id;
          let title  = '';
          if(now_id != 6 && obj.level != 3){
            if( !_this.secView ){
              title = `是否进入 ${obj.divisionName} 主页`;
            }else{
              now_id = 0;
              title = `是否返回GIS主页`;
            }
            _this.$confirm(title, '', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: ''
            }).then(() => {
              _this.secView = !_this.secView;
              _this.getData( now_id );
            }).catch(() => {

            });
          }
        });
      },
      //公司简介
      getCompanyInfo( id ){
        let _this = this;
        for(let i in this.divisionArr){
          let now = this.divisionArr[i];
          if(now.id == id){
            _this.companyInfo = now;
            //文本溢出处理
            let companyDes = document.getElementById('companyDes');
            _this.$nextTick(()=>{
              let companyDesH = companyDes.getBoundingClientRect().height;
              let conH = companyDes.parentElement.getBoundingClientRect().height;
              _this.showEllipsis = companyDesH > conH ? true: false;
            })
            _this.desFlag = true;
          }
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .con-wrap{
    position: relative;
    width: 100%;
    #bmap{
      width: 100%;
      height: calc(100vh - 80px);
    }
    .info-btn{
      position: absolute;
      top: 10%;
      right: 2%;
      z-index: 99999;
      background: #1264b9;
      &:hover{
        color: #fff;
      }
    }
    .pos-box{
      position: absolute;
      width: 370px;
      //background: rgba(0,0,0, 0.7);
      background: #fff;
      z-index: 99999;
      color: #333;
      h2{
        font-size: 22px;
        font-weight: 600;
        width: 100%;
        text-align: center;
        margin: 20px auto 10px;
      }
      .more-btn{
        width: 100%;
        text-align: center;
        cursor: pointer;
        color: #333;
        font-size:19px;
        font-weight: 600;
        height: 40px;
        line-height: 40px;
      }
      &.des-wrap{
        top: 80px;
        left: 0;
        height: 90vh;
        padding: 0 15px 0 25px;
        //p{
        //  line-height: 40px;
        //  color: #eee;
        //}
        .msg-box {
          font-size: 18px;
          font-weight: 300;
          line-height: 40px;
          color: #333;
        }
        .company-name{
          font-size: 18px;
          color: #333;
          font-weight: 600;
        }
        .des-con{
          //height: 650px;
          height: 66vh;
          overflow: hidden;
          position: relative;
          font-size: 18px;
          line-height: 40px;
          .company-des{
            color: #333;
            text-indent: 2em;
          }
          span{
            content: "...";
            position: absolute;
            bottom: 22px;
            right: 0;
            padding-right: 6px;
            //background: rgba(0, 0, 0, 1);
          }
        }
      }
      &.pic-wrap{
        top: 80px;
        right: 0;
        padding:0 20px;
        height: 401px;
        p{
          font-size: 16px;
          line-height: 22px;
          height: 22px;
          margin-bottom: 10px;
          color: #eee;
        }
        .pic-con{
          img{
            width: 155px;
            height: 100px;
            margin-bottom: 20px;
            display: inline-block;
            &:first-child{
              margin-right: 20px;
            }
          }

        }
      }
      &.video-wrap{
        top: 481px;
        right: 0;
        /*height: 479px;*/
        padding:0 20px;
        h2{
          .iconfont{
            cursor: pointer;
            font-size: 20px;
            color: #bbb;
          }
        }
        .video-box {
          margin-bottom: 10px;
          &:nth-child( 2n+1 ){
            margin-right: 4.5%;
          }
          video {
            width: 155px;
            height: 100px;
            /*margin-right: 20px;*/
          }
          .video-title {
            height: 20px;
            line-height: 20px;
            font-size: 15px;
            text-align: center;
            color: #eee;
            cursor: pointer;
          }
        }
        .no-data{
          height: 150px;
          line-height: 150px;
          text-align: center;
          font-size: 18px;
        }
      }
      &.three-wrap{
        position: absolute;
        top: 713px;
        right: 0;
        padding-bottom: 16px;
        .three-con{
          width: 330px;
          height: 172px;
          margin:0 auto;
          cursor: pointer;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .close-img{
      position: absolute;
      top: 24px;
      right: 20px;
      width: 20px;
      height: 20px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      z-index: 99999;
    }
    .camera-wrap{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999999;
      display: none;
      .video-details-warp{
        position: absolute;
        top: 16%;
        left: 27%;
        padding: 20px;
        z-index: 999999;
        background: #12162b;
        p{
          color: #fff;
          font-size: 16px;
          margin: 0;
        }
        #myPlayer {
          margin-top: 10px;
          width: 850px;
          height: 600px;
          z-index: 999999;
        }
        span{
          color: #fff;
          position: absolute;
          top: 16px;
          right: 25px;
          z-index: 999999;
          cursor: pointer;
        }
      }
    }
    /* 跳转按钮 */
    .btn-wrap{
      position: absolute;
      bottom: 15px;
      left: 0;
      /*width: 100%;*/
      text-align: center;
      z-index: 99999;
      //background: rgba(0, 0, 0, 0.7);
      border-radius: 6px;
      background: #fff;
      padding: 12px 30px;
      margin-left: 40%;
      .el-button{
        margin-left: 30px;
        //border: 2px solid #198DFF;
      }

    }
  }

</style>
